import {useResources} from '@/di/di.root-container.hooks';

import {Image} from '@/ui/kit/Image/Image';

import s from './KeyVisual.module.css';

export const KeyVisual = (): JSX.Element => {
  const {
    content: {
      mainPage: {titleImage},
    },
  } = useResources();

  return (
    <Image className={s.titleImage} pictureClassName={s.titlePictures} src={titleImage.src} alt={titleImage.alt} />
  );
};
